<div class="wasted-overlay" *ngIf="isVisible">
  <div class="wasted-container">
    <h1 class="wasted-title">WASTED</h1>
    <p class="wasted-score">Score: {{ score }}</p>
    <button class="play-again-btn" #playAgainBtn (click)="onPlayAgain()">Play again</button>
  </div>
</div>
